<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-05 17:32:40
 * @LastEditTime: 2019-08-18 20:13:27
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div>
           <el-form ref="form1" :model="form1" label-width="120px" :inline="true">
          <el-form-item label="关键词:">
            <el-input v-model="form1.keywords"  clearable placeholder="产品编号,产品名称" ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSearch()">搜索</el-button>
            <el-button type="primary" @click="onExport()">导出</el-button>
          </el-form-item>
        </el-form>
        <div>剩余库存总数:{{total}}</div>
        <el-table
          ref="multipleTable"
          :data="tableData"
          v-loading="loading"
          border
          stripe
          style="width: 100%;margin: 20px"
        >
          <el-table-column prop='product_sn' label="产品编号" fixed></el-table-column>
          <el-table-column prop='product_name' label="产品名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop='product_specs' label="规格" show-overflow-tooltip></el-table-column>
          <el-table-column prop='inwarehouse_num' label="入库数量" show-overflow-tooltip></el-table-column>
          <el-table-column prop='outwarehouse_num' label="出货数量" show-overflow-tooltip></el-table-column>
          <el-table-column prop='returngoods_num' label="退货数量" show-overflow-tooltip></el-table-column>
          <el-table-column prop='retail_num' label="零售数量" show-overflow-tooltip></el-table-column>
          <el-table-column prop='stock_total' label="剩余数量" show-overflow-tooltip></el-table-column>

          <el-table-column prop label="操作" width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button type="text" size="small" @click='getDetail(scope.row)'>明细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin: 20px 0"
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="pageNo2"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageSize2"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize2"
        ></el-pagination>
          <el-dialog
                :visible.sync="detail"
                width="40%"
                title='查看明细'
                >
                      <el-button  size="small" @click="exportDetail()" style='margin-bottom:10px;'>导出明细</el-button>
            <el-table
                  :data="tableData2"
                  style="width: 100%"
                  border
                    v-loading="loading"
                 >
                          <el-table-column
                                  prop="stock_out_sn"
                                  label="所属订单号"
                                  >
                          </el-table-column>
                          <el-table-column
                                  prop="from_name"
                                  label="出货人"
                                >
                          </el-table-column>
                          <el-table-column
                                  prop="created_at"
                                  label="入库时间"
                                 
                                 >
                          </el-table-column>
                          <el-table-column
                                  prop="real_stock_out_num"
                                  label="产品数量"
                                  show-overflow-tooltip>
                          </el-table-column>
                          <el-table-column
                                  prop="logistics_code"
                                  label="物流码"
                                  >
                          </el-table-column>
                          <el-table-column
                                  prop="code_name"
                                  label="标签类型"
                          fixed="right"

                                 >
                          </el-table-column>
                        
                    </el-table>
                                   <!--分页-->
                <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageNo"
                        :page-sizes="[5, 10, 20, 50]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize">
                </el-pagination>
                    </el-dialog>
    </div>
</template>

<script>
export default {
    name:'my',
    data(){
        return{
                form1:{
                    keywords:''
                },
                tableData2:[],
                detail:false,
                loading:false,
                     pageNo2: 1,
                pageSize2: 20,
                totalSize2: 0,
                tableData:[],
                total:0,
                      pageNo: 1,
                pageSize: 20,
                totalSize: 0,
                detailData:{}
        }
    },
   methods:{
        onSearch(){
            this.loading=true
        this.$get('logistics','/stocks',{
            per_page:this.pageSize2,
            page:this.pageNo2,
            keywords:this.form1.keywords
        }).then(res=>{
            this.tableData=res.data
            this.totalSize2=res.meta.total
            this.total=res.real_stock_out_num
            this.loading=false
        })
    },
    onExport(){
           var access_tokens = localStorage.getItem('access_token');
            console.log(access_tokens)
          window.open( process.env.VUE_APP_URL
                        +'/stocks.export?'+
                       'lang=' + '' +'&is_export=1'+
                       '&keywords='+this.form1.keywords
                       +'&signature='+ this.$md5(access_tokens)
                    )
    },
       handleSizeChange2(val) {
            this.pageSize2 = val;
            this.pageNo2 = 1;
            this.onSearch();
        },
        handleCurrentChange2(val) {
            this.pageNo2 = val;
            this.onSearch();
        },
         handleSizeChange(val) {
            this.pageSize = val;
            this.pageNo = 1;
            this.getDetail();
        },
        handleCurrentChange(val) {
            this.pageNo = val;
            this.getDetail();
        },
        // 获取明细
        getDetail(data){
            this.loading=true
            this.detail=true
            if(data){
            this.detailData=data
            }
            this.$get('logistics','/stocks/datas',{
                per_page:this.pageSize,
                page:this.pageNo,
                product_sn:this.detailData.product_sn
            }).then(res=>{
                this.tableData2=res.data
                this.totalSize=res.meta.total
                this.loading=false
            })
        },
        exportDetail(){
            // 
             let url = '',access_tokens = localStorage.getItem('access_token');
            
               window.open(process.env.VUE_APP_URL
                        +'/stocks/datas.export?'+
                       '&lang=' + '' +'&is_export=1'+
                       '&product_sn='+this.detailData.product_sn
                       +'&signature='+ this.$md5(access_tokens)
                    )
        }
   },
   created(){
       console.log('aa')
       this.onSearch()
   }
}
</script>

